import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// import ButtonGroup from '@material-ui/core/ButtonGroup';
import {
  DeleteOrder,
  GetOrders,
  // GetOrdersForAdmin,
  // GetOrdersByUser,
  // AcceptOrder,
} from '../../fetchs';
import { Grid } from '@material-ui/core';
// import { Link } from 'react-router-dom';
// import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AlertDialog from '../Prompt/alert-dialog.component';
import CircularProgress from '@material-ui/core/CircularProgress';
// import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
// import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import './order-list.styles.css';

const headCells = [
  { id: 'purchaseCode', numeric: false, disablePadding: true, label: 'شماره فاکتور' },
  { id: 'buyer', numeric: true, disablePadding: false, label: 'نام خریدار' },
  { id: 'purchaseDate', numeric: false, disablePadding: true, label: 'تاریخ' },
  { id: 'paidValue', numeric: false, disablePadding: true, label: 'مقدار پرداخت' },
  { id: 'reduceValue', numeric: true, disablePadding: false, label: 'مقدار کسر' },
  { id: 'postalCode', numeric: true, disablePadding: false, label: 'کد پستی' },
  { id: 'receiverPhone', numeric: false, disablePadding: true, label: 'شماره تحویل گیرنده' },
  { id: 'status', numeric: true, disablePadding: false, label: 'وضعیت' },
  { id: 'sumPrice', numeric: false, disablePadding: true, label: 'جمع کل' },
  { id: 'purchasedProductsCount', numeric: false, disablePadding: true, label: 'تعداد اقلام' },
  { id: 'tools', numeric: false, disablePadding: true, label: '' }
];

export default class OrderList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      rowsPerPage: 20,
      rowsLength: 0,
      rows: [],
      // customerId: null,
      alertDialog: false,
      deleteId: null,
      loading: false,
    }
  }

  componentDidMount() {
    // if (this.props.match.params.customerId) {
    //   this.setState({ customerId: this.props.match.params.customerId }, () => {
    //     this.getOrders();
    //   });
    // } else {
    this.getOrders();
    // }
  }

  getOrders = () => {
    this.setState({ loading: true });
    const offset = this.state.page * this.state.rowsPerPage;
    const limit = this.state.rowsPerPage;
    // if (this.state.customerId) {
    //   GetOrdersByUser(this.state.customerId, offset, limit)
    //     .then(response => {
    //       this.setState({ loading: false });
    //       return response.json();
    //     }).then(responseJson => {
    //       this.setState({ rows: responseJson.data, rowsLength: responseJson.count });
    //     }).catch(error => {
    //       this.setState({ loading: false });
    //       console.error(error);
    //     });
    // // } else if (this.state.justWaitForAccept) {
    //   GetOrdersForAdmin(offset, limit)
    //     .then(response => {
    //       this.setState({ loading: false });
    //       return response.json();
    //     }).then(responseJson => {
    //       this.setState({ rows: responseJson.data, rowsLength: responseJson.count });
    //     }).catch(error => {
    //       this.setState({ loading: false });
    //       console.error(error);
    //     });
    // } else {
    GetOrders(offset, limit)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      }).then(responseJson => {
        this.setState({ rows: responseJson.data, rowsLength: responseJson.count });
      }).catch(error => {
        this.setState({ loading: false });
        console.error(error);
      });
    // }
  }

  // handleAdminAccept = (orderId) => {
  //   this.setState({ loading: true });
  //   AcceptOrder(orderId, true)
  //     .then(response => {
  //       this.setState({ loading: false });
  //       if (response.status === 200)
  //         this.getOrders();
  //       return response.json();
  //     })
  //     .then(responseJson => {

  //     })
  //     .catch(error => {
  //       console.error(error);
  //     })
  // }

  // handleAdminDecline = (orderId) => {
  //   this.setState({ loading: true });
  //   AcceptOrder(orderId, false)
  //     .then(response => {
  //       this.setState({ loading: false });
  //       if (response.status === 200)
  //         this.getOrders();
  //       return response.json();
  //     })
  //     .then(responseJson => {

  //     })
  //     .catch(error => {
  //       console.error(error);
  //     })
  // }

  // handleJustWaitForAdmin = (value) => {
  //   this.setState({ justWaitForAccept: value }, () => {
  //     this.getOrders();
  //   });
  // }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getOrders();
    });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.getOrders();
    });
  }

  handleDelete = () => {
    this.setState({ alertDialog: false, loading: true });
    DeleteOrder(this.state.deleteId)
      .then(response => {
        this.setState({ loading: false });
        if (response.status === 200)
          this.getOrders();
        return response.json();
      })
      .then(responseJson => {

      })
      .catch(error => {
        console.error(error);
      })
  }

  handlePrepareDelete = (id) => {
    this.setState({ deleteId: id, alertDialog: true });
  }

  handleCloseDialog = () => {
    this.setState({ alertDialog: false });
  }

  isActive = (value) => {
    return (value === this.state.justWaitForAccept) ? 'active' : 'default';
  }

  emptyRows = () => this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.rowsLength - this.state.page * this.state.rowsPerPage);

  render() {
    return (
      <div className="root">
        <Paper className="paper">
          <Toolbar>
            <Grid item xs={12} sm={2}>
              <div className="title">
                {(
                  <Typography variant="h6" id="tableTitle">
                    لیست فروش
                </Typography>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={7}>

            </Grid>
            <Grid item xs={12} sm={3}>
              {/* <ButtonGroup fullWidth variant="contained" aria-label="full width outlined button group">
                <Button className={this.isActive(false)} onClick={() => this.handleJustWaitForAdmin(false)}>همه</Button>
                <Button className={this.isActive(true)} onClick={() => this.handleJustWaitForAdmin(true)}>تأیید ادمین</Button>
              </ButtonGroup> */}
            </Grid>
          </Toolbar>
          <div className="tableWrapper">
            <Table
              className="table"
              aria-labelledby="tableTitle"
              size={'medium'}
            >
              <TableHead>
                <TableRow>
                  {headCells.map(headCell => (
                    <TableCell
                      key={headCell.id}
                      align={'center'}
                      padding={headCell.disablePadding ? 'none' : 'default'}
                    >
                      <TableSortLabel
                        active={false}
                      >
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.rows.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                    >
                      <TableCell align="center">{row.purchaseCode}</TableCell>
                      <TableCell align="center">{row.buyer.firstName} {row.buyer.lastName}</TableCell>
                      <TableCell align="center">{row.purchaseDatePersian}</TableCell>
                      {/* <TableCell align="center">{row.offer ? <CheckCircleOutlineIcon /> : <HighlightOffIcon />}</TableCell> */}
                      <TableCell align="center">{row.paidValue}</TableCell>
                      <TableCell align="center">{row.reduceValue}</TableCell>
                      <TableCell align="center">{row.postalCode}</TableCell>
                      <TableCell align="center">{row.receiverPhone}</TableCell>
                      <TableCell align="center">{row.status}</TableCell>
                      <TableCell align="center">{row.sumPrice}</TableCell>
                      <TableCell align="center">{row.purchasedProducts.length}</TableCell>
                      <TableCell align="center" style={{ width: '105px' }}>
                        {/* <Link to={`/main/order/${row.orderId}`}>
                          <EditIcon color="primary" />
                        </Link> */}
                        <DeleteIcon
                          className="deleteIcon"
                          onClick={() => this.handlePrepareDelete(row.purchaseId)} />
                      </TableCell>
                    </TableRow>
                  );
                })}
                {this.emptyRows > 0 && (
                  <TableRow style={{ height: 49 * this.emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          {this.state.loading && <CircularProgress size={24} className="buttonProgress" />}
          <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={this.state.rowsLength}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            backIconButtonProps={{
              'aria-label': 'previous page',
            }}
            nextIconButtonProps={{
              'aria-label': 'next page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        <AlertDialog
          open={this.state.alertDialog}
          title="اخطار"
          body="آیا از حذف فاکتور اطمینان دارید؟"
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog} />
      </div>
    )
  };
}